<template>
  <div class="mobile-table-content">
    <div class="table-title">
      <div class="title-left"><i class="el-icon-s-management" />还款信息</div>
      <div class="title-right"></div>
    </div>
    <!-- 投放信息 -->
    <div class="list-content">
      <CommonDetail :listConfig="listConfig" :listData="formData">
      </CommonDetail>
    </div>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />待结清款项
        </div>
        <div class="title-right"></div>
      </div>
      <!-- 其他应收款项 -->
      <TableCustom
        :readOnly="true"
        :tableParams="tableParams"
        :tableData="tableData"
        style="margin-left: 10px"
      >
      </TableCustom>
    </template>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />本批次投放信息
        </div>
        <div class="title-right"></div>
      </div>
      <!-- 本批次投放信息 -->

      <div class="list-content">
        <CommonDetail :listConfig="listBatchConfig" :listData="formData">
        </CommonDetail>
      </div>
    </template>
  </div>
</template>
<script>
import CommonDetail from "@/components/workflowComponents/mobile/commonDetail";
import TableCustom from "@/components/tableCustom/tableCustom";
import { mapGetters } from "vuex";
import * as api from "@/api/factoring/factoring";
import SelectInput from "@/components/commonSelect/selectInput";
import SelectDrawer from "@/components/workflowComponents/mobile/selectDrawer";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import { floatAdd } from "@/util/util";
export default {
  name: "mobileInvestmentLoanManagement",
  mixins: [workFlow, util],
  data() {
    return {
      tableData: [],
      formOneData: {},
      formTwoData: {},
      listConfig: [
        {
          label: "项目名称",
          prop: "projectName",
        },
        {
          label: "保理合同",
          prop: "contractName",
        },
        {
          label: "卖方（债权人）",
          prop: "sellerCustName",
        },
        // {
        //   label: "内部收益率",
        //   prop: "usedFinancingQuota",
        //   formatter: (label, value) => {
        //     return "%";
        //   },
        // },
        {
          label: "业务主办",
          prop: "managerUserName",
        },
        {
          label: "业务协办",
          prop: "assistUserName",
        },
      ],
      listBatchConfig: [
        {
          label: "预计还款日期",
          prop: "prepaymentDate",
        },
        {
          label: "归还本金",
          prop: "principal",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "本金大写金额",
          prop: "principalStr",
        },
        {
          label: "归还利息",
          prop: "interestChange",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "利息大写金额",
          prop: "interestStr",
        },
        {
          label: "保证金抵扣金额",
          prop: "depositDeductionAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "归还总金额",
          prop: "realReturnStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
      ],
      tableParams: {
        index: false,
        indexLabel: "序号",
        align: "center",
        column: [
          {
            label: "批次",
            prop: "investBatch",
            formatter: (label, value) => {
              return `第${value}批`;
            },
          },
          {
            label: "笔数",
            prop: "paymentBatch",
            formatter: (label, value) => {
              return `第${value}笔`;
            },
          },
          {
            label: "期数",
            prop: "issue",
            formatter: (label, value) => {
              return `第${value}期`;
            },
          },
          {
            label: "还款日",
            prop: "rentDay",
            formatter: (label, value) => {
              return `${String(value).substring(0, 4)}-${String(
                value
              ).substring(4, 6)}-${String(value).substring(6, 8)}`;
            },
          },
          {
            label: "每期应还",
            prop: "cashFlow",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
          },
          {
            label: "每期本金",
            prop: "principal",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
          },
          {
            label: "每期利息",
            prop: "interest",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
          },
          {
            label: "备注",
            prop: "remarks",
          },
        ],
      },
    };
  },
  components: {
    CommonDetail,
    SelectInput,
    SelectDrawer,
    TableCustom,
  },
  props: {
    listData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    flowData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    listData: {
      handler(newData, oldData) {
        if (newData.id && newData.id != "") {
          this.dealDetailData(newData);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async dealDetailData(data) {
      this.tableData = data.calc.rentplans;
      let setData = {};
      setData.principalStr = this.changeNumMoneyToChinese(Number(data.principal))
      setData.interestStr = this.changeNumMoneyToChinese(Number(data.interest))
      this.selectProjectId = data.projectInfoId;
      this.selectContractId = data.conManageId;
      setData.projectName = data.projectName;
      setData.projectInfoId = data.projectInfoId;
      setData.contractName = data.contractName;
      setData.contractId = data.conManageId;
      // 测算归还本金
      setData.calcPrincipal = this.getMoney(Number(data.calc.principal));
      // 测算归还利息
      setData.calcInterest = this.getMoney(Number(data.calc.interest));
      // 客户名称
      setData.sellerCustName = data.sellerCustName;
      // 协办
      setData.assistUser = data.assistUser;
      setData.assistUserName = data.assistUserStr;
      // 主办
      setData.managerUser = data.managerUser;
      setData.managerUserName = data.managerUserStr;
      // 部门
      setData.managerDept = data.managerDept;
      // 预计还款日
      setData.prepaymentDate = data.prepaymentDate;
      // 保证金抵扣金额
      setData.depositDeductionAmount = data.depositDeductionAmount;
      setData.depositDeductionAmountStr = this.getMoney(
        Number(data.depositDeductionAmount)
      );
      // 实际归还本金
      setData.principal = data.principal;
      setData.principalChange = this.getMoney(Number(data.principal));
      // 实际归还利息
      setData.interest = data.interest;
      setData.interestChange = this.getMoney(Number(data.interest));
      // 实际归还金额
      setData.realReturnStr = this.getMoney(
        Number(data.principal) + Number(data.interest)
      );

      this.formData = setData;
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-table-content {
  .table-title {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    .title-left {
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right {
      font-size: .38rem;
      color: #ccc;
    }
  }
  .list-content {
    .info-one {
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left {
        width: 30%;
        color: #999;
        font-size: .38rem;
      }
      .info-right {
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
  }
  .item-one {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: 0.35rem 0.4rem;
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    .item-index {
      font-size: .38rem;
      line-height: 0.7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line {
      font-size: .38rem;
      line-height: 0.55rem;
      color: #999;
      span {
        margin-left: 0.3rem;
      }
    }
    .remark-content {
      font-size: .38rem;
      color: #333;
      line-height: 0.7rem;
    }
  }
}
.info_right_edit {
  color: #409eff !important;
  cursor: pointer !important;
}
</style>